import { POSTAL_CODE_FORMAT } from "./postalCode";

type ZipRange = readonly [first: number, last: number, stateCode: string];

const US_ZIP3_RANGES: readonly ZipRange[] = [
  [5, 5, "NY"],
  [6, 7, "PR"],
  [8, 8, "VI"],
  [9, 9, "PR"],
  [10, 27, "MA"],
  [28, 29, "RI"],
  [30, 38, "NH"],
  [39, 49, "ME"],
  [50, 54, "VT"],
  [55, 55, "MA"],
  [56, 59, "VT"],
  [60, 69, "CT"],
  [70, 89, "NJ"],
  [100, 149, "NY"],
  [150, 196, "PA"],
  [197, 199, "DE"],
  [200, 200, "DC"],
  [201, 201, "VA"],
  [202, 205, "DC"],
  [206, 219, "MD"],
  [220, 245, "VA"],
  [246, 268, "WV"],
  [270, 289, "NC"],
  [290, 299, "SC"],
  [300, 319, "GA"],
  [320, 349, "FL"],
  [350, 368, "AL"],
  [369, 369, "MS"],
  [370, 385, "TN"],
  [386, 397, "MS"],
  [398, 399, "GA"],
  [400, 427, "KY"],
  [430, 459, "OH"],
  [460, 479, "IN"],
  [480, 499, "MI"],
  [500, 528, "IA"],
  [530, 549, "WI"],
  [550, 567, "MN"],
  [570, 577, "SD"],
  [580, 588, "ND"],
  [590, 599, "MT"],
  [600, 629, "IL"],
  [630, 658, "MO"],
  [660, 679, "KS"],
  [680, 693, "NE"],
  [700, 714, "LA"],
  [716, 729, "AR"],
  [730, 732, "OK"],
  [733, 733, "TX"],
  [734, 749, "OK"],
  [750, 799, "TX"],
  [800, 816, "CO"],
  [820, 831, "WY"],
  [832, 838, "ID"],
  [840, 847, "UT"],
  [850, 865, "AZ"],
  [870, 884, "NM"],
  [885, 885, "TX"],
  [889, 898, "NV"],
  [900, 961, "CA"],
  [967, 968, "HI"],
  [969, 969, "GU"],
  [970, 979, "OR"],
  [980, 994, "WA"],
  [995, 999, "AK"],
];

const CANADIAN_FIRST_LETTER: Readonly<Record<string, string>> = {
  A: "NL",
  B: "NS",
  C: "PE",
  E: "NB",
  G: "QC",
  H: "QC",
  J: "QC",
  K: "ON",
  L: "ON",
  M: "ON",
  N: "ON",
  P: "ON",
  R: "MB",
  S: "SK",
  T: "AB",
  V: "BC",
  Y: "YT",
};

const NUNAVUT_PREFIXES = new Set(["X0A", "X0B", "X0C"]);

function canadianRegion(compact: string): string | undefined {
  const letter = compact.charAt(0);
  if (letter === "X") return NUNAVUT_PREFIXES.has(compact.slice(0, 3)) ? "NU" : "NT";
  return CANADIAN_FIRST_LETTER[letter];
}

function usRegion(zip: string): string | undefined {
  const prefix = Number(zip.slice(0, 3));
  return US_ZIP3_RANGES.find(([first, last]) => prefix >= first && prefix <= last)?.[2];
}

export function regionCodeForPostalCode(raw: string | undefined): string | undefined {
  const comparable = POSTAL_CODE_FORMAT.toComparable(raw);
  if (!comparable) return undefined;
  return /^\d{5}$/.test(comparable) ? usRegion(comparable) : canadianRegion(comparable);
}
